export const GET_IFRAME_REQUEST = "GET_IFRAME_REQUEST";
export const GET_IFRAME_SUCCESS = "GET_IFRAME_SUCCESS";
export const GET_IFRAME_ERROR = "GET_IFRAME_ERROR";
